/* eslint-disable no-param-reassign */
import { util } from 'echarts';
import type { PresetMode } from '../..';
import { ThemeParser } from '../../../core/theme';
import { normalizeToArray } from '../../../util/utils';
import { getDefaultLineSeries } from '../../ainvest/series/line';

function parseLineSeries(
  seriesOptions: Parameters<ThemeParser>[0]['series'],
  option: Parameters<ThemeParser>[0],
  themeMode: PresetMode
) {
  (seriesOptions as []).forEach((series, index) => {
    if (series.type !== 'line') {
      return;
    }
    const defaultOption = util.merge(
      getDefaultLineSeries(index, series, option, themeMode),
      { z: 6 },
      true
    );
    seriesOptions[index] = util.merge(defaultOption, series, true);
  });
}

export function lineThemeParse(...args: Parameters<ThemeParser>) {
  const [option, chart] = args;
  option.series = normalizeToArray(option.series);
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';

  parseLineSeries(option.series, option, themeMode);
}
